// extracted by mini-css-extract-plugin
module.exports = {"unionPhotoWrap":"UnionPhoto_style_unionPhotoWrap__3a7TG"};